import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { APP_ROUTES } from "@core/constants/auth-constants";
import { LoggerService } from "@core/logging/logger.service";

/**
 * Dynamically loads protected routes after authentication to keep role strings and
 * feature route data out of the initial unauthenticated bundle.
 */
@Injectable({ providedIn: "root" })
export class ProtectedRoutesLoaderService {
  private loaded = false;
  private loadingPromise: Promise<void> | null = null;
  private readonly log = inject(LoggerService).createContext(
    "ProtectedRoutesLoader"
  );

  constructor(private readonly router: Router) {}

  loadProtectedRoutes(): Promise<void> {
    if (this.loaded) {
      return Promise.resolve();
    }
    if (this.loadingPromise) {
      return this.loadingPromise; // prevent duplicate imports
    }

    this.loadingPromise = import("../../protected.routes")
      .then((module) => {
        const protectedRoutes = module.protectedRoutes;
        // Preserve existing public routes except wildcard, then append protected, then wildcard.
        const publicRoutes = this.router.config.filter((r) => r.path !== "**");
        const wildcard = this.router.config.find((r) => r.path === "**") || {
          path: "**",
          redirectTo: APP_ROUTES.LOGIN.substring(1),
        };
        this.router.resetConfig([
          ...publicRoutes,
          ...protectedRoutes,
          wildcard,
        ]);
        this.loaded = true;
      })
      .catch((err) => {
        this.log.error("Failed to load protected routes", err);
      })
      .finally(() => {
        this.loadingPromise = null;
      });

    return this.loadingPromise;
  }
}
